"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.teaser.cta.label': 'Hacer pregunta',
    'chat.teaser.default.prompt1.description': '¿De qué está construida la atmósfera de Marte?',
    'chat.teaser.default.prompt1.text': '¿De qué está construida la atmósfera de Marte?',
    'chat.teaser.default.prompt2.description': '¿Qué tan rápido puede correr un caballo?',
    'chat.teaser.default.prompt2.text': '¿Qué tan rápido puede correr un caballo?',
    'chat.teaser.default.prompt3.description': '¿Cómo cambiar una llanta pinchada?',
    'chat.teaser.default.prompt3.text': '¿Cómo cambiar una llanta pinchada?',
};
